/**
 * EngagementBar — Shared 4-icon engagement bar for all FoodCard variants.
 * Reposts | Not for me (ThumbsDown) | Foodlist (Layers) | FoodCard icon
 */
import { Layers, Repeat2, ThumbsDown } from 'lucide-react';
import FoodCardIcon from '../FoodCardIcon';

const EngagementBar = ({
  repostCount = 0, onRepost, reposted = false,
  onNotMyVibe, vibeDisliked = false,
  inFoodlist, foodlistCount, onFoodlistToggle, saveAnim,
  onFoodCardTap, claimed, claimLoading,
  testId,
  compact = false,
}) => {
  const iconSz = compact ? 'w-5 h-5' : 'w-6 h-6';
  const labelSz = compact ? 'text-[9px]' : 'text-[10px]';
  const px = compact ? 'px-2' : 'px-3';
  const fcSize = compact ? 24 : 28;

  return (
    <div className="flex items-start justify-between pt-3 border-t border-gray-100/80" data-testid={`engagement-bar-${testId}`}>
      {/* Reposts */}
      <button onClick={onRepost}
        className={`relative flex flex-col items-center gap-1 ${px} py-1 rounded-xl transition-all ${reposted ? 'text-emerald-500' : 'text-gray-400 hover:text-gray-600 hover:bg-gray-50'}`}
        data-testid={`action-repost-${testId}`}>
        <Repeat2 className={iconSz} />
        <span className={`${labelSz} font-bold`}>{repostCount} <span className="font-medium">Repost{repostCount !== 1 ? 's' : ''}</span></span>
      </button>

      {/* Not for me */}
      <button onClick={vibeDisliked ? undefined : onNotMyVibe}
        className={`flex flex-col items-center gap-1 ${px} py-1 rounded-xl transition-all ${vibeDisliked ? 'text-red-400' : 'text-gray-400 hover:text-red-400 hover:bg-red-50'}`}
        data-testid={`action-notforme-${testId}`}>
        <ThumbsDown className={iconSz} />
        <span className={`${labelSz} font-medium`}>{vibeDisliked ? 'Noted' : 'Not for me'}</span>
      </button>

      {/* Foodlist (Layers) */}
      <button onClick={onFoodlistToggle}
        className={`relative flex flex-col items-center gap-1 ${px} py-1 rounded-xl transition-all ${inFoodlist ? 'text-[#FF6B35]' : 'text-gray-400 hover:text-gray-600 hover:bg-gray-50'}`}
        data-testid={`action-foodlist-${testId}`}>
        <Layers className={`${iconSz} ${inFoodlist ? 'fill-current' : ''}`} />
        <span className={`${labelSz} font-bold transition-all ${saveAnim ? 'text-[#FF6B35] scale-110 animate-pulse' : ''}`}>{foodlistCount} <span className="font-medium">Foodlist</span></span>
        {saveAnim && <span className={`absolute -top-1 right-0 ${labelSz} text-[#FF6B35] font-bold animate-bounce`}>+1</span>}
      </button>

      {/* FoodCard (Post/Collect) */}
      <button onClick={onFoodCardTap}
        disabled={claimLoading || claimed}
        className={`relative flex flex-col items-center gap-1 ${px} py-1 rounded-xl transition-all ${claimed ? 'text-emerald-500' : 'text-gray-400 hover:text-gray-600 hover:bg-gray-50'} disabled:opacity-80`}
        data-testid={`action-postfoodcard-${testId}`}>
        {claimLoading ? (
          <div className={`${iconSz} border-2 border-gray-300 border-t-[#FF6B35] rounded-full animate-spin`} />
        ) : (
          <FoodCardIcon size={fcSize} active={claimed} className={claimed ? 'text-emerald-500' : ''} />
        )}
        <span className={`${labelSz} font-bold ${claimed ? 'text-emerald-500' : ''}`}>
          {claimed ? 'Posted' : 'FoodCard'}
        </span>
      </button>
    </div>
  );
};

export default EngagementBar;
